var Promotion = Backbone.Model.extend({

    defaults: {
        "id": 'noop',
        "title": '',
        "shortTitle": '',
        "termsConditions": '',
        "images": [],
        "sash": '',
        "discountPercentage": null,
        "limit": null,
        "siteUrl": null,
        "startDate": null,
        "endDate": null,
        "skus": [ ]
    }

});

export default Promotion;
